export const getProductsIncluded = (packageTag, labels) => {
  let productsIncluded;

  switch (packageTag) {
    case 'F':
      productsIncluded = labels.productsIncludedFlightOnly;
      break;
    case 'FHF':
      productsIncluded = labels.productsIncluded;
      break;
    case 'FHFHF':
      productsIncluded = labels.productsIncludedStopover;
      break;
    case 'FCHF':
    case 'FHCF':
      productsIncluded = labels.productsIncludedCruise;
      break;
    case 'FHCHF':
      productsIncluded = labels.productsIncludedCruiseTwoHotels;
      break;
    case 'FCF':
      productsIncluded = labels.productsIncludedCruiseNoHotel;
      break;
    case 'H':
      productsIncluded = labels.productsIncludedHotelOnly;
      break;
    default:
      productsIncluded = labels.productsIncluded;
      break;
  }

  return productsIncluded;
};
